import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';

import { Notifications_OperationService } from './Notifications.operation.service';
import { FootprintApiManager_OperationService } from './FootprintApiManager.operation.service';


@Injectable({ providedIn: 'root' })
export class app_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
    this.Notifications = this.injector.get(Notifications_OperationService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_OperationService);
  }

    public Notifications: Notifications_OperationService;
    public FootprintApiManager: FootprintApiManager_OperationService;
  public app: app_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/app/operations/${operationName}/isauthorized`, null);
  }
}
